import 'air-datepicker/dist/js/datepicker.min'
import 'air-datepicker/dist/js/i18n/datepicker.en'

export default function AirDatepickerCom(app) {

    // We need to skip the [onSelect] events triggered during component initialization
    let initialized = false

    $('.kx-air-datepicker').each(function() {
        const $this = $(this)
        const datepicker = $this.datepicker({
            // todayButton: new Date(),
            // inline: true,
            autoClose: true,
            dateFormat: 'M d, yyyy',
            onSelect: function(formattedDate, date, inst) {
                formattedDate ? $this.addClass('not-empty') : $this.removeClass('not-empty')
                if(!initialized) return
                app.events.emit('kx_date_select', { formattedDate, date, inst })
            },
            // onHide: function(inst, animationCompleted) {
            //     if(!initialized) return
            //
            //     if(animationCompleted) {
            //         // app.events.emit('kx_date_select', { inst, animationCompleted })
            //     }
            // }
        }).data('datepicker')

        let interval = $this.val().trim()
        if(interval) {
            interval = interval.split(' - ')
            for(const date of interval) {
                datepicker.selectDate(new Date(date))
            }
        }

        // Event to set values
        app.events.on('kx_datepickerSetSelected', function(data){
            if($this.attr('data-map') === data.dataMap) {
                datepicker.selectDate(new Date(data.value))
            }
        })
    })

    initialized = true

}
